import styled from 'styled-components';
import CategoryCard from '../shared/CategoryCard';
import ShopCard from '../ShopCard/ShopCard';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import { CATEGORIES, DOM_SEARCH_RESULTS, GRID, SHOPS } from '../../../../lib/constants';
import { saveShop, removeShopById } from '../../../../lib/user';
import { toSlug } from '../../../../lib/utils';
import { addItemsToDataLayer } from '../../../../lib/dataLayerUtils';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';

const SearchResultsContainerDiv = styled.div`
  border-bottom: 1px solid ${p => p.theme.c.border.primary};
`;

const DesktopSearchResultsContainerDiv = styled(SearchResultsContainerDiv)`
  padding-bottom: ${p => p.theme.unit(8)}; 
`;

const MobileSearchResultsContainerDiv = styled(SearchResultsContainerDiv)`
  padding-bottom: ${p => p.theme.unit(4)}; 
  margin: 0 -${p => p.theme.unit(4)};
`;

const SearchResultsTitleH2 = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${({ theme }) => theme.c.text.primary};
  border-top: 1px solid ${(p) => p.theme.c.border.primary};
  margin: 0;
`;

const DesktopSearchResultsTitleH2 = styled(SearchResultsTitleH2)`
  padding: ${p => p.theme.unit(8)} 0 ${p => p.theme.unit(4)} 0;
  margin-top: ${p => p.theme.unit(8)};
`;

const MobileSearchResultsTitleH2 = styled(SearchResultsTitleH2)`
  padding: ${p => p.theme.unit(6)} ${p => p.theme.unit(4)} ${p => p.theme.unit(2)} ${p => p.theme.unit(4)};
  margin-top: ${p => p.theme.unit(4)};
`;

const CategoriesContainer = styled.div`
  margin-left: ${p => p.mobile ? p.theme.unit(3) : p.theme.unit(-1)};
  display: flex;
  flex-wrap: wrap;
`;

const CategoriesGutter = styled.div`
  margin: ${p => p.theme.unit(1)};
`;

const SearchResults = (props) => {
  const {
    shopHits,
    categoryHits,
    searchStoreTitle,
    searchCategoriesTitle,
    locale,
    pageStateModifiers,
    userData,
  } = props;

  const dataLayerCategories = (categoryHits && categoryHits.length) ?
    categoryHits.map((category) => {
      if (category && category.slug) {
        const newCategory = Object.assign({}, category);
        newCategory.dataLayerId = `${toSlug(CATEGORIES)}_${toSlug(category.slug)}`;
        return newCategory;
      }
      return category;
    }) : [];

  if (window) {
    addItemsToDataLayer(dataLayerCategories, CATEGORIES);
  }

  const CategoriesSectionToUse = ({ mobile }) => {
    return (dataLayerCategories && dataLayerCategories.length >= 1 ?
      (<CategoriesContainer mobile={mobile}>
        { dataLayerCategories.map((category, index) => {
          return (<CategoriesGutter key={`${category.name}-${index}`}>
            <CategoryCard
              {...category}
              locale={locale}
              dataContextContainer={DOM_SEARCH_RESULTS}
              dataIndex={index + 1} />
          </CategoriesGutter>);
        })}
      </CategoriesContainer>) : null);
  };

  const favShops = userData && userData.shops ? userData.shops : [];
  const favShopIds = favShops.map(shop => shop.id);

  const ShopsSectionToUse = () => {
    return (shopHits && shopHits.length >= 1 ? (
      <LayoutCollectionView
        favItemIds={favShopIds}
        items={shopHits}
        Comp={ShopCard}
        itemType={SHOPS}
        viewType={GRID}
        saveItemHandler={saveShop}
        removeItemHandler={removeShopById}
        pageStateModifiers={pageStateModifiers}
        locale={locale} />) : null);
  };

  const DesktopBody = () => (
    <DesktopSearchResultsContainerDiv>
      {Boolean(categoryHits?.length) && (
        <>
          <DesktopSearchResultsTitleH2>{searchCategoriesTitle}</DesktopSearchResultsTitleH2>
          <CategoriesSectionToUse />
        </>
      )}
      {Boolean(shopHits?.length) && (
        <>
          <DesktopSearchResultsTitleH2>{searchStoreTitle}</DesktopSearchResultsTitleH2>
          <ShopsSectionToUse />
        </>
      )}
    </DesktopSearchResultsContainerDiv>
  );

  const MobileBody = () => (
    <MobileSearchResultsContainerDiv>
      {Boolean(categoryHits?.length) && (
        <>
          <MobileSearchResultsTitleH2>{searchCategoriesTitle}</MobileSearchResultsTitleH2>
          <CategoriesSectionToUse mobile />
        </>
      )}
      {Boolean(shopHits?.length) && (
        <>
          <MobileSearchResultsTitleH2>{searchStoreTitle}</MobileSearchResultsTitleH2>
          <ShopsSectionToUse />
        </>
      )}
    </MobileSearchResultsContainerDiv>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />);
  return renderComp;
};

export default SearchResults;
